"use client"
import {useEffect, useState} from "react";
import {useAppSelector} from "@/redux/hooks";
import {RootState} from "@/redux/store";

export default function useSearchLogic() {
    const productsParams = useAppSelector((state: RootState) => state.products)
    const [totalSelectedItemsCount, setTotalSelectedItemsCount] = useState<number>(0)

    const count = (() => {
        let c = 0;
        if (productsParams.Company) c += productsParams.Company.length;
        if (productsParams.Car) c += productsParams.Car.length;
        if (productsParams.Section) c += productsParams.Section.length;
        if (productsParams.OnlyNewests) c++;
        if (productsParams.OnlyOffers) c++;
        if (productsParams.SearchText && productsParams.SearchText.length > 3) c++;
        return c;
    })();

    useEffect(() => {
        setTotalSelectedItemsCount(prev => {
            if (prev === count) return prev;
            return count;
        });
    }, [count]);

    return {
        totalSelectedItemsCount,
    };
}
